var map = {
	"./arrow.svg": 15628,
	"./icon-email.svg": 53144,
	"./icon-eyes.svg": 95811,
	"./icon-facebook.svg": 89745,
	"./icon-google.svg": 42915,
	"./icon-id.svg": 90773,
	"./icon-play.svg": 70583,
	"./icon-purchasedgames.svg": 24102,
	"./icon-return.svg": 36571,
	"./icon-shut.svg": 84466,
	"./icon/icon-Discount-active.svg": 2805,
	"./icon/icon-Discount-week.svg": 97125,
	"./icon/icon-Gift-Box-active.svg": 73200,
	"./icon/icon-Gift-Box-week.svg": 23202,
	"./icon/icon-badge.svg": 11658,
	"./icon/icon-cloud-storage.svg": 9777,
	"./icon/icon-coin.svg": 31683,
	"./icon/icon-discount.svg": 34957,
	"./icon/icon-exclusiveGames.svg": 24021,
	"./icon/icon-expression.svg": 31929,
	"./icon/icon-fast.svg": 98148,
	"./icon/icon-game.svg": 15934,
	"./icon/icon-gift-box.svg": 96874,
	"./icon/icon-gold-discount.svg": 92757,
	"./icon/icon-hd.svg": 65171,
	"./icon/icon-is-vip.svg": 1701,
	"./icon/icon-lock.svg": 33062,
	"./icon/icon-not-vip.svg": 5214,
	"./icon/icon-playvideo.svg": 9771,
	"./icon/icon-red-name.svg": 48753,
	"./icon/icon-star.svg": 49173,
	"./icon/icon-time.svg": 58079,
	"./icon/icon-vip-active.svg": 62245,
	"./icon/icon-vip-week.svg": 35028,
	"./icon/icon-vip.svg": 21054,
	"./icon/tag-100G.svg": 85968,
	"./icon/tag-50G.svg": 12092,
	"./icon_expand.svg": 56712,
	"./icon_language.svg": 90655,
	"./icon_vip-Crown.svg": 40435,
	"./icon_vip.svg": 37763,
	"./language_icon_n.svg": 86075,
	"./language_icon_s.svg": 12062,
	"./tab_icon_vip.svg": 23796,
	"./vip_icon_time.svg": 65773
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 58278;